import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {DsBoxModule, DsButtonModule, DsModalModule} from '@bmw-ds/components';
import {TranslateModule} from '@ngx-translate/core';
import {VehicleCustomerReference} from '../awp-dms-interface/models/vehicle';
import {CustomerSelectionService} from './customer-selection.service';

@Component({
  selector: 'app-customer-selection-overlay',
  templateUrl: './customer-selection-overlay.component.html',
  styleUrls: ['./customer-selection-overlay.component.scss'],
  imports: [DsModalModule, DsBoxModule, DsButtonModule, TranslateModule]
})
export class CustomerSelectionOverlayComponent implements OnInit, OnDestroy {
  private readonly customerSelectionService: CustomerSelectionService = inject(CustomerSelectionService);

  visible: boolean = false;
  customerList: VehicleCustomerReference[] = [];

  private selectionCallback: ((customer: VehicleCustomerReference) => void) | null = null;
  private cancelCallback: (() => void) | null = null;

  ngOnInit(): void {
    this.customerSelectionService.registerSelectionHandler(
      (customers: VehicleCustomerReference[]) => this.show(customers)
    );
  }

  ngOnDestroy(): void {
    this.customerSelectionService.unregisterSelectionHandler();
  }

  show(customerList: VehicleCustomerReference[]): Promise<VehicleCustomerReference> {
    this.customerList = customerList;
    this.visible = true;
    return new Promise<VehicleCustomerReference>((resolve, reject) => {
      this.selectionCallback = resolve;
      this.cancelCallback = reject;
    });
  }

  customerSelected(customer: VehicleCustomerReference): void {
    this.visible = false;
    this.selectionCallback?.(customer);
  }

  close(): void {
    this.visible = false;
    this.cancelCallback?.();
  }

  getCustomerDisplayName(customer: VehicleCustomerReference): string {
    if (customer.firstName && customer.lastName) {
      return `${customer.firstName} ${customer.lastName}`;
    }
    if (customer.lastName) {
      return customer.lastName;
    }
    if (customer.companyName) {
      return customer.companyName;
    }
    return customer.dmsCustomerId;
  }
}

